import React from 'react';
import iframe from '../../services/iframe';
import styles from './ResizeHandler.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { thunkUpdateUserAgent } from '../../state/userAgent/userAgentThunks';
import { selectDexfSettingsHaveBeenLoaded } from '../../state/dexfSettings/dexfSettingsSelectors';
import { selectCurrentView } from '../../state/navigation/navigationSelectors';
import {
  selectOverlayActive,
  selectScrollException,
} from '../../state/popups/popupsSelectors';
import {
  selectIsMobile,
  selectOrientation,
} from '../../state/userAgent/userAgentSelectors';
import store from '../../state';

const ResizeHandler = ({ children }: any) => {
  const dispatch = useDispatch();
  const element = React.useRef(null);

  const dexfSettingsHaveBeenLoaded = useSelector(
    selectDexfSettingsHaveBeenLoaded
  );
  const currentView = useSelector(selectCurrentView);
  const modalOpen = useSelector(selectOverlayActive);
  const orientation = useSelector(selectOrientation);
  const isMobile = useSelector(selectIsMobile);
  const scrollException = useSelector(selectScrollException);
  const shouldScroll = !isMobile || scrollException;

  window.addEventListener('orientationchange', function () {
    this.setTimeout(() => {
      dispatch(thunkUpdateUserAgent());
    }, 100);
  });

  const scrollToTop = (xy: object, smooth: boolean) => {
    const { x, y } = { x: 0, y: 0, ...xy };
    const behavior = smooth ? 'smooth' : 'auto';
    try {
      if (window.top) {
        window.top.scrollTo({ top: y, left: x, behavior: behavior });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const setHeight = () => {
    // NIF markets can't handle window.parent. Catch possible error.
    try {
      iframe.setHeight(window.parent.innerHeight);
    } catch (error) {}
  };

  const updateIframe = () => {
    dispatch(thunkUpdateUserAgent());

    if (selectOverlayActive(store.getState())) {
      shouldScroll && scrollToTop({ y: 150 }, true);
      return setHeight();
    }

    iframe.update();
  };

  React.useEffect(() => {
    dexfSettingsHaveBeenLoaded && updateIframe();
  }, [dexfSettingsHaveBeenLoaded, modalOpen, currentView, orientation]);

  const resizeObserver = React.useRef(
    new ResizeObserver(
      ([entry]) => dexfSettingsHaveBeenLoaded && updateIframe()
    )
  );

  React.useEffect(() => {
    //Try scrolling to top in available markets
    dexfSettingsHaveBeenLoaded && scrollToTop({}, false);
  }, [dexfSettingsHaveBeenLoaded, currentView]);

  const resizedContainerRef = React.useCallback(
    container => {
      element.current = container;
      if (container !== null) resizeObserver.current.observe(container);
      else if (resizeObserver.current) resizeObserver.current.disconnect();
    },
    [resizeObserver.current]
  );

  return (
    <div ref={resizedContainerRef} className={styles.ResizeHandler}>
      {children}
    </div>
  );
};

export default ResizeHandler;
